<template>
	<div class="row">
    <div class="col-md-12" style="background:var(--blue)"><p class="header-bar">BALANCE SUMMARY REPORT</p></div>
		<TableView :col="columns" :getData="getData" :Options="{tblContainerClass:'innerTable-style'}"/>           
	</div>
</template>
<script>
import common from '@/assets/js/common.js';
export default {
  components: {
    TableView : () => import('@/components/Common/DataTable/Table') ,
  },
  mixins: [common],
  props: ['row','report_date','base_currency'],
  data(){
  	return {
      columns: (() => {
        const cols = [
          { title: 'LCY', field: 'lcy', tdClass:"p1rem"},
          { title: 'SD Opening BAL', field: 'sd_open_cash_balance', tdComp: 'Number', 'floatLength': 2 },
          { title: 'SD Closing BAL', field: 'sd_closing_cash_balance', tdComp: 'Number', 'floatLength': 2 },
          { title: 'TD Opening BAL', field: 'td_open_cash_balance', tdComp: 'Number', 'floatLength': 2 },
          { title: 'TD Closing BAL', field: 'td_closing_cash_balance', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Notional Opening Cash BAL', field: 'open_cash_balance', tdComp: 'Number', 'floatLength': 2},
          { title: 'Realized PNL', field: 'realized_pnl', tdComp: 'Number', 'floatLength': 2},
          { title: 'Deposit/Withdrawal', field: 'deposit_withdraw', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Notional Closing Cash BAL', field: 'closing_cash_balance', tdComp: 'Number', 'floatLength': 2},
          { title: 'Unrealized PNL', field: 'unrealized_pnl', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Total Equity', field: 'total_equity', tdComp: 'Number', 'floatLength': 2 },
          { title: 'Margin Used', field: 'margin_used' , tdComp: 'Number', 'floatLength': 2},
          { title: 'Margin (Excess/Deficit)', field: 'margin_excess_deficit' , tdComp: 'Number', 'floatLength': 2},
          { title: 'FX Rate', field: 'fx_rate', tdComp: 'Number' },
        ]
        const groupsDef = {
          Normal: [],
          Sortable: [],
          Extra: ['Operation']
        }
        return cols.map(col => {
          Object.keys(groupsDef).forEach(groupName => {
            if (groupsDef[groupName].includes(col.title)) {
              col.group = groupName
            }
          })
          return col
        })
      })(),
  	}
  },
  created() {
  },
  methods: {
    async getData(query, filter) {
      const { limit = 10, offset = 0, sort = '', order = '' } = JSON.parse(JSON.stringify(query));
      let uri = 'balance_report?account_number='+this.row.account_number+'&report_date='+this.report_date+'&base_cur='+this.base_currency;
      return await this.call_axios(uri).then(res => {
        res.response.data.Pagination = false;
        return res;
      });
    }
  }
}
</script>
<style>
.header-bar{
  text-align: center;
  vertical-align: middle !important;
  font-weight: 700;
  color:#fff;
  padding: 10px 0 0 0;
}
</style>